import siteConfig from "../lib/siteConfig";
const content = {
  navigation: [
    { label: "Palvelumme", url: "/palvelumme" },
    { label: "Hinnasto", url: "/hinnasto" },
    { label: "Yhteystiedot", url: "/yhteystiedot" },
    { label: "Ajanvaraus", url: siteConfig.bookingUrl },
  ],
  rightsReserved: "Kaikki oikeudet pidätetään",
};
export default content;
